// extracted by mini-css-extract-plugin
export default {"stickyHeader":"BulkUsersUploadActivity_stickyHeader__zaBwG"};